<template>
  <div class="chat-container">
    <div class="chat-header">
      <div>{{title}}</div>
    </div>
    <ChatMessageList :role="role" :list="list"></ChatMessageList>
    <div class="chat-input">
      <textarea
          :placeholder="placeholder"
          class="chat-input-target"
          @keyup.enter="onInputMsg"
          v-model="inputMsg"></textarea>
    </div>
    <div class="chat-footer">
      <div style="display: flex;">
        <div class="chat-flex-1">
          <slot name="bottom-left"/>
        </div>
        <div>
          <ChatButton @click="onInputMsg">发送</ChatButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ChatButton from '@/components/ChatButton';
import ChatMessageList from '@/components/ChatMessageList';

export default {
  name: 'ChatContainer',
  components: {ChatButton, ChatMessageList},
  props: {
    placeholder: String,
    title: String,
    messages: Array,
    role: String,
  },
  data() {
    return {
      inputMsg: null,
    };
  },
  computed: {
    list() {
      return this.messages || [];
    },
  },
  methods: {
    onInputMsg() {
      const input = this.inputMsg;
      if (input) {
        this.inputMsg = null;
        this.$emit('send', input);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.chat-container {
  display: flex;
  height: 100%;
  flex-direction: column;
  background: #eee;
  max-width: 480px;

  $h-padding: 20px;

  & > .chat-header {
    padding: 0 $h-padding;
    line-height: 64px;
    background: #EEE;
    font-size: 16px;
    color: #3EB2D9;
    font-weight: bold;
    box-sizing: border-box;

    &::after {
      display: block;
      content: '';
      background: #F2F2F2;
      width: 100%;
      border-bottom: 1px solid #ddd;
    }
  }

  & > .chat-input {
    position: relative;
    padding: $h-padding $h-padding 0;
    height: 120px;
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      left: $h-padding;
      right: $h-padding;
      top: 0;
      display: block;
      border-top: solid 1px #AAA;
    }
  }

  & .chat-input-target {
    padding: 4px 8px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    outline: none;
    resize: none;
    line-height: 26px;
    background: transparent;
    border-color: transparent;
    transition-duration: .2s;

    &:focus, &:hover {
      background: #fff;
      border-color: transparent;
    }
  }

  & > .chat-footer {
    padding: 5px $h-padding 20px;
    box-sizing: border-box;
  }

  & .chat-flex-1 {
    flex: 1;
  }
}
</style>